import React,{useState,useLayoutEffect,useEffect,useRef} from 'react';
import Typography from '@material-ui/core/Typography';
import Slider from '@material-ui/core/Slider';
import { Sentry } from "react-activity";
import "react-activity/dist/Sentry.css";

function useForceUpdate(){
    const [value, setValue] = useState(0); // integer state
    return () => setValue(value => value + 1); // update the state to force render
}


function App() {
  
  const forceUpdate = useForceUpdate();

  const [data,setData]=useState([])

  
  const refcheckboxs = useRef([]);

  const [activePage,setActivePage] =useState(1);


  const [search,setSearch]=useState("")

  const [products,setProducts]=useState([])
  const [kategoriler,setKategoriler]=useState([])
  const [renkler,setRenkler]=useState([])
  const [selecteds,setSelecteds]=useState([])
  const [kategoriVisible,setKategoriVisible]=useState(true)
  const [renkVisible,setRenkVisible]=useState(false)

  const [agirlik, setAgirlik] =  useState([1,5000]);
  const [yukseklik, setYukseklik] =  useState([1,3000]);
  const [genislik, setGenislik] =  useState([1,3000]);
  const [sizes,setSizes]=useState({hacim_min:0,hacim_max:10,agirlik_min:0,agirlik_max:10,yukseklik_min:0,yukseklik_max:10})

  const [pageNumberList,setPageNumberList]=useState(undefined)

  const [currentPage,setCurrentPage]=useState(0)

  let pageNumbers=[]
  
  const dataPerPage=20

  for (let index = 0; index < Math.ceil(data.length/20); index++) {

    pageNumbers.push({number:index,active:index==0? true : false})

  }
  
  const handlePageChange=(pageNumber)=>{
    setActivePage(pageNumber)
  }

  const resetFilter = () => {
    
    if(sizes!=null){
      setAgirlik([sizes.hacim_min,sizes.hacim_max])
      setYukseklik([sizes.yukseklik_min,sizes.yukseklik_max])
      setGenislik([sizes.genislik_min,sizes.genislik_max])
    }
    setSearch("")
    setKategoriVisible(true)
    setRenkVisible(false)
    setSelecteds([])
    refcheckboxs.current.map((e)=>{
      e.checked=false
    })
  };

  
  useLayoutEffect(() => {
    fetchData()
  }, [])

  const fetchData=()=>{
    fetch('https://baharcampackaging.com/getproducts.php').then((response)=>response.json()).then(response=>{ setData(response); setProducts(response) })
    fetch('https://baharcampackaging.com/getcategories.php').then((response)=>response.json()).then(response=>{ setKategoriler(response);  })
    fetch('https://baharcampackaging.com/getcolors.php').then((response)=>response.json()).then(response=>{ setRenkler(response);   })
    fetch('https://baharcampackaging.com/getsizes.php').then((response)=>response.json()).then(response=>{ setSizes(response); 
    setAgirlik([response.hacim_min,response.hacim_max])
    setYukseklik([response.yukseklik_min,response.yukseklik_max])
    setGenislik([response.genislik_min,response.genislik_max])
    })
    console.log(data,kategoriler,renkler,sizes)
  }
  
 

  useEffect(() => {
    let filterResult=products.filter(item=>((item.hacim*1)>=agirlik[0] && (item.hacim*1)<=agirlik[1]) ? true : false)
    filterResult=filterResult.filter(item=>((item.genislik*1)>=genislik[0] && (item.genislik*1)<=genislik[1]) ? true : false)
    filterResult=filterResult.filter(item=>((item.yukseklik*1)>=yukseklik[0] && (item.yukseklik*1)<=yukseklik[1]) ? true : false)
    if(search!=""){
      filterResult=filterResult.filter(item=> item.baslik.toUpperCase().replaceAll(" ","").indexOf(search.toUpperCase().replaceAll(" ",""))!=-1 ? true : false )
    }
    if(selecteds.length>0){
      filterResult=filterResult.filter(item=>{
        if(selecteds.indexOf(('renk:'+item.renk))!=-1){
          return true
        }else if(selecteds.indexOf(('kategori:'+item.kategori))!=-1){
          return true
        }else{
          return false
        }
      })
    }
    
    
    setData(filterResult)
    //console.log("filterResult",filterResult,agirlik[0],agirlik[1])

  }, [agirlik,yukseklik,genislik,selecteds,search])
  
  const getPageNumbers=(pageNumberItem)=>{

    return(

      <ul className="pagination">
      
        <button disabled={currentPage==0 ? true : false} onClick={()=>pageDown()} > <i className="fa fa-chevron-left"></i> </button>
        
        {
        
          pageNumberItem.map(function(element){
          
            return(
              
              <>

                <button key={'mgoUs'+element.number} onClick={()=>pageChange(element)} style={{backgroundColor:element.active? '#267F7F':null,color:element.active? '#fff':null}}>{element.number+1}</button>
              
              </>

            )

          })
        
        }

        <button disabled={currentPage+1== Math.ceil(data.length/dataPerPage) ? true : false} onClick={()=>pageUp()} > <i className="fa fa-chevron-right"></i> </button>
      
      </ul>
    
    )
  
  }
  const pageDown=async()=>{

    let newNumbers=await []
    
    pageNumbers.forEach(element => {
    
      newNumbers.push({number:element.number,active:currentPage-1==element.number ? true : false})
    
    });
    
    pageNumbers= await newNumbers
    
    const page=await setCurrentPage(currentPage-1)
    
    const setter=await setPageNumberList(newNumbers)
  
  }
  
  const pageUp=async()=>{
  
    let newNumbers=await []
  
    pageNumbers.forEach(element => {
  
      newNumbers.push({number:element.number,active:currentPage+1==element.number ? true : false})
  
    });
  
    pageNumbers= await newNumbers
  
    const page=await setCurrentPage(currentPage+1)
  
    const setter=await setPageNumberList(newNumbers)
  
  }
  
  const pageChange=async(main)=>{
  
    let newNumbers=await []
  
    pageNumbers.forEach(element => {
  
      newNumbers.push({number:element.number,active:main.number==element.number ? true : false})
  
    });
  
    pageNumbers= await newNumbers
  
    const page=await setCurrentPage(main.number)
  
    const setter=await setPageNumberList(newNumbers)

  }
  return (
    <>
    {
      (products.length==0 ||kategoriler.length==0 || renkler.length==0 || sizes=={hacim_min:0,hacim_max:10,agirlik_min:0,agirlik_max:10,yukseklik_min:0,yukseklik_max:10} ) ? 
       <div className="loading">
         <Sentry size={250} />
       </div>
       :
      <div className="App">
        
        <div className="filter">
          <button onClick={()=>resetFilter()}>Clear Filter</button>

          <div className="kategoriler">
            <input type="text" value={search} onChange={(e)=>setSearch(e.target.value)} placeholder="Search product name..." />
          </div>

          <div className="kategoriler" onClick={()=>setKategoriVisible(!kategoriVisible)}>
            <h1>Categories <strong ><i className={kategoriVisible ? 'fa fa-arrow-up' : 'fa fa-arrow-down'}></i></strong></h1>
            <div className="kategori lister" style={{display:kategoriVisible ? 'block' : 'none'}}>
              {
                kategoriler.map((kategori,index)=>{
                  return(
                    <React.Fragment key={`kategori-${index}`}>
                    
                    <label >
                      <input type="checkbox" ref={e=>refcheckboxs.current[index]=e} defaultChecked={false} onChange={(e)=>{
                        if(e.target.checked==true){
                          setSelecteds([...selecteds,'kategori:'+kategori])
                        }else{
                          setSelecteds(selecteds.filter(item=> item=='kategori:'+kategori ? false : true))
                        }
                      }} /> {kategori}
                    </label>
                    </React.Fragment>
                  )
                })
              }
            </div>
          </div>

          {/* <div className="kategoriler" onClick={()=>setRenkVisible(!renkVisible)}>
            <h1>Renkler<strong  ><i className={renkVisible ? 'fa fa-arrow-up' : 'fa fa-arrow-down'}></i></strong></h1>
            <div className="kategori lister" style={{display:renkVisible ? 'block' : 'none'}}>
              {
                renkler.map((renk,index)=>{
                  return(
                    <label key={`renk-${index}`}>
                      <input type="checkbox" defaultChecked={false} onChange={(e)=>{
                        if(e.target.checked==true){
                          setSelecteds([...selecteds,'renk:'+renk])
                        }else{
                          setSelecteds(selecteds.filter(item=> item=='renk:'+renk ? false : true))
                        }
                      }} /> {renk}
                    </label>
                  )
                })
              }
              
            </div>
          </div> */}

          <div className="kategoriler">
            <h1>Capacity <span>(cc)</span></h1>
            <div className="kategori">
              <div>
                <input type="text" value={agirlik[0]} onChange={(e)=>setAgirlik([e.target.value,agirlik[1]])} />
                <input type="text" value={agirlik[1]} onChange={(e)=>setAgirlik([agirlik[0],e.target.value])} />
              </div>
              <Slider
                value={agirlik}
                min={(sizes.hacim_min)}
                max={(sizes.hacim_max)}
                style={{color:'#007f7f'}}
                onChange={(event,newValue)=>setAgirlik(newValue)}
                valueLabelDisplay="off"
              />
            </div>
          </div>
          

           <div className="kategoriler">
            <h1>Height <span>(mm)</span></h1>
            <div className="kategori">
              <div>
                <input type="text" value={yukseklik[0]} onChange={(e)=>setYukseklik([e.target.value,yukseklik[1]])} />
                <input type="text" value={yukseklik[1]} onChange={(e)=>setYukseklik([yukseklik[0],e.target.value])} />
              </div>
              
              <Slider
                value={yukseklik}
                min={sizes.yukseklik_min}
                max={sizes.yukseklik_max}
                style={{color:'#007f7f'}}
                onChange={(event,newValue)=>setYukseklik(newValue)}
                valueLabelDisplay="off"
              />
            </div>
          </div>


          <div className="kategoriler">
            <h1>Width <span>(mm)</span></h1>
            <div className="kategori">
              <div>
                <input type="text" value={genislik[0]} onChange={(e)=>setGenislik([e.target.value,genislik[1]])} />
                <input type="text" value={genislik[1]} onChange={(e)=>setGenislik([genislik[0],e.target.value])} />
              </div>
              <Slider
                value={genislik}
                min={sizes.genislik_min}
                max={sizes.genislik_max}
                style={{color:'#007f7f'}}
                onChange={(event,newValue)=>setGenislik(newValue)}
                valueLabelDisplay="off"
              />
            </div>
          </div> 


        </div>
        <div className="products">
          {
            data.length==0 ?
            <div className="loading" style={{fontSize:26}}>
              <center>Ürün bulunamadı</center><br/>
            </div>
            :
            <div className="listerp">
            {
              data.slice(currentPage*dataPerPage,currentPage*dataPerPage+dataPerPage).map((element,index)=>{
                return (
                  <React.Fragment itemClass="page-item" linkClass="page-link" key={`product-${index}`}>
                    <a href={`https://baharcampackaging.com/urunlerimiz.php?id=`+element.id}>
                    <div className="productCard"  >
                      <img src={element.resim} className="productImage" />
                      <div className="productTitle">
                        {element.baslik}
                      </div>
                      <div className="productProperties">
                        <div><i className="fa fa-arrows-alt-h"></i> <span className="space"></span> <span>{element.genislik}mm</span> </div>
                        <div><i className="fa fa-arrows-alt-v"></i> <span className="space"></span> <span>{element.yukseklik}mm</span> </div>
                        <div className="full">
                      <svg xmlns="http://www.w3.org/2000/svg" width="13.5" height="13.5" viewBox="0 0 13.5 13.5">
                        <path id="Path_22970" data-name="Path 22970" d="M65.815,341.329a.527.527,0,0,0,.528-.527v-6.645a2.112,2.112,0,0,0-2.109-2.109H54.952a2.112,2.112,0,0,0-2.109,2.109v9.281a2.111,2.111,0,0,0,2.109,2.109h9.281a2.112,2.112,0,0,0,2.109-2.109.527.527,0,0,0-1.055,0,1.056,1.056,0,0,1-1.055,1.055H54.952a1.056,1.056,0,0,1-1.055-1.055v-9.281a1.056,1.056,0,0,1,1.055-1.055h9.281a1.056,1.056,0,0,1,1.055,1.055V340.8A.527.527,0,0,0,65.815,341.329ZM58.8,342.858a.527.527,0,0,0,.528-.527v-1.978a1.32,1.32,0,0,0-1.318-1.318H56.033a.527.527,0,0,0,0,1.055h1.5l-2.185,2.184a.527.527,0,1,0,.746.746l2.184-2.185v1.5A.527.527,0,0,0,58.8,342.858Zm5.067-7.616-2.185,2.185h1.5a.527.527,0,1,1,0,1.055H61.2a1.32,1.32,0,0,1-1.318-1.318v-1.978a.527.527,0,1,1,1.055,0v1.5l2.185-2.185a.527.527,0,0,1,.746.746Z" transform="translate(-52.843 -332.048)" fill="#000"/>
                      </svg>
 <span className="space-reverse"></span>{element.hacim} <span>cc</span> </div>
                      </div>
                    </div>
                    </a>

                  </React.Fragment>
                )
              })
            }
            {
              data.length<20 ? <></> : pageNumberList!=undefined  ? getPageNumbers(pageNumberList) : getPageNumbers(pageNumbers)
            }
            
            </div>
          }
        </div>
      </div>
    }
    </>
    
  );
}

export default App;
